module.exports = __webpack_public_path__ + "static/media/IMG_8183.71e4c7da.jpg";